// extracted by mini-css-extract-plugin
export default {"container":"orderTrackPage_container__fPzsY","content":"orderTrackPage_content__kRGVs","header":"orderTrackPage_header__oZWdL","payment":"orderTrackPage_payment__I5zVL"};